import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import { Observable } from 'rxjs';
import {UserService} from "../services/user.service";


@Injectable({
  providedIn: 'root'
})
export class GestionBusesGuard implements CanActivate {

  constructor(private userService: UserService, private router: Router) {

  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if(!this.userService.tienePermiso('BUSES_VER_VISTA')) {
      this.router.navigateByUrl(this.userService.getPrimeraRutaPermitida());
      return false;
    }

    return true;
  }






}
